var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramSmarterDecisions40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SmarterDecisions40",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search40"
  }), /*#__PURE__*/React.createElement("g", {
    id: "04-Honeycomb-Foundation/pictogram/Medium./Ideas64"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "pictogram",
    transform: "translate(12.500000, 7.000000)",
    stroke: "#4F4C4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.4075,20.9654862 C9.75683333,21.0052765 9.989,21.0026815 10.104,20.9577012 C13.014,19.8345761 15,16.9587738 15,13.7217445 C15,9.47629016 11.611,6 7.5,6 C3.389,6 0,9.47629016 0,13.7217445 C0,16.9670778 1.995,19.8480702 4.916,20.9654862 C5.036,21.0115046 5.23033333,21.0115046 5.499,20.9654862 C6.69166667,20.9654862 7.35866667,20.9654862 7.5,20.9654862 C7.64133333,20.9654862 8.27716667,20.9654862 9.4075,20.9654862 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFCC00",
    points: "5 21 10 21 10 25 5 25"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    points: "5 21 5 15 7.53 17.7793846 10 15 10 21"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Emphasis",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 7.48235294,
    y1: 0,
    x2: 7.48235294,
    y2: 3,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 2,
    x2: 14.1176471,
    y2: 5,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 2,
    x2: 1.88235294,
    y2: 5,
    id: "Path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramSmarterDecisions40);
export default __webpack_public_path__ + "static/media/pictogramSmarterDecisions40.6fb0deae9ccb5c91736c7f7dafc95446.svg";
export { ForwardRef as ReactComponent };